import {
    customGetWishListLines, customGetWishListLinesV2, customSaveForLaterApiParameter,
} from "@NA/Services/ADISaveForLater";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";

type HandlerType = CustomApiHandler<customSaveForLaterApiParameter, WishListLineModel>;

export const PdpLoadSaveForLater: HandlerType = async (props: any) => {
    props.apiResult = await customGetWishListLines(props.parameter);
};

export const PdploadWishListsSaveForLater: HandlerType = props => {
    props.dispatch(loadWishLists({}));
};

export const PdpLoadSaveForLaterV2: HandlerType = async (props: any) => {
    props.apiResult = await customGetWishListLinesV2(props.parameter);
    if (typeof props.parameter.onSuccess === "function") {
        props.parameter.onSuccess();
    }
};

export const chain = [PdpLoadSaveForLater, PdploadWishListsSaveForLater, PdpLoadSaveForLaterV2];

const pdpSaveForLater = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        wishListId: "",
        productId: "",
        qtyOrdered: 0,
        unitOfMeasure: "",
        properties: {
            name: "SAVEDITEM@#$",
        },
        cartLineId: "",
        parameter: null,
        name: "SAVEDITEM@#$",
    },
    "SaveForLater",
);
export default pdpSaveForLater;
